import { SchoolList } from './school-list';

export default SchoolList;
